module.exports = __webpack_public_path__ + "assets/img/spinning-cocktail.eb5009e1.png";